module.exports = __webpack_public_path__ + "static/media/arrowUpIcon.e44439ac.svg";